import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { PhilosophySection } from './components/PhilosophySection';
import { LogoShowcase } from './components/LogoShowcase';
import { ServicesSection } from './components/ServicesSection';
import { BioSection } from './components/BioSection';
import { FooterSection } from './components/FooterSection';
import './App.css';

function App() {
  return (
    <div className="App" data-testid="turinga-dev-app">
      <Navigation />
      <main>
        <HeroSection />
        <PhilosophySection />
        <LogoShowcase />
        <ServicesSection />
        <BioSection />
        <FooterSection />
      </main>
    </div>
  );
}

export default App;
